import React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { zIndex } from '../theme/constants';
import { ReactComponent as Umbrella } from 'common-assets/assets/icons/umbrella.svg';
import { useIsMobile } from '../utils/useIsMobile';
import { Tooltip } from '../Tooltip/Tooltip';

import useStyles from './UmbrellaIcon.style';

export interface UmbrellaIconProps {
  className?: string,
  color?: string,
  width?: number,
  height?: number,
  umbrellaName?: string,
  tooltipTitleClassName?: string,
}

const UmbrellaIcon: React.FC<UmbrellaIconProps> = ({color, width = 40, height = 40, className, umbrellaName, tooltipTitleClassName }) => {
  const [t] = useTranslation("components");
  const c = useStyles({ color, width, height, isDarkTheme: false });
  const isMobile = useIsMobile();
  const { tooltipAppBarZIndex } = zIndex;

  const icon = (
    <div className={clsx('umbrella-icon', c.root, className)}>
      <Umbrella strokeWidth={0}/>
    </div>
  );

  const wrapWithToolTip = (children: React.ReactElement) => {
    const tooltipText = umbrellaName
      ? t('fund-list.umbrella-tooltip', { umbrellaName })
      : '';

    return (
      <Tooltip
        customZIndex={tooltipAppBarZIndex}
        title={
          <div className={tooltipTitleClassName}>
            {isMobile && icon}
            <span>{tooltipText}</span>
          </div>
        }
        arrow
        placement="top"
      >
        {children}
      </Tooltip>
    );
  };

  if (umbrellaName) {
    return wrapWithToolTip(icon);
  } else {
    return icon;
  }
};

export { UmbrellaIcon };
